import {MULTI_SYNTH} from 'constants/instrument-types.js';

export const isSynth = (track) => {
    return track.instrument && track.instrument.getInstrumentType() === MULTI_SYNTH;
};
